import { mapGetters } from "vuex";
import * as d3 from 'd3';

var homeMixin = {
  data(){
    return {
      color_m : '#4CAF50', //green
      color_h : '#FF9800', //orange
      color_idx : '#607D8B',
      want_open: false,
      data_dialog: undefined,
      //color_idx : '#85137b'
      /*base_benef : {
        "action": null,
        "report": null,
        "segment": null,
        "type_beneficiary": null,
        "impact": null,
        "number_men": null,
        "number_women": null,
        "action_define": false,
        //extras:
        "pobla": null,
      }*/
    }
  },
  computed:{
    ...mapGetters(["show_charts"]),
  },
  methods: {
    format_perc(v, dec=1){
      return (!Number.isNaN(v)) ? d3.format(`.${dec}f`)(v) : '-'
    },
    axisValue(axis){
      return this.axes_means ? this.axes_means[`${axis.id}`] : axis.mean_value || 0
    },
    colorPallete(axis=null){
      var forced_palette = false
      var color
      if (axis){
        color = axis.color
        if (axis.initial_color && axis.last_color)
          forced_palette = true
      }
      else
        color = this.color_idx

      return d3.interpolateHsl(
        forced_palette ? axis.initial_color : d3.rgb(color).brighter(1.2), 
        forced_palette ? axis.last_color : d3.rgb(color).darker(1))
    },
    calcEqTooltip({row=null, col=null, td= null}){
      var pob = (gen) => td ? td[gen] : row[`${gen}${col.id}`]
      var tot = pob('m') + pob('h')
      let calcGen = (gen) => {
        var p = pob(gen)
        return `<span class="${gen=='m' ? 'green':'orange'}--text"> 
          ${this.format_perc(p / tot*100, 0)}% 
          ${gen=='m'? 'Mujeres': 'Hombres'} (${d3.format(",")(p)}) </span>`
      }
      return `${calcGen('m')} <br> ${calcGen('h')}`
    },
    calcHeatColor(value){
      if (isNaN(value)) return '#e4e4e4'
      var colors = d3.scaleLinear()
        .domain([0, 0.5 , 1])
        .range([this.color_h, "white", this.color_m]);
      return colors(value)
    },
    open_dialog_ic(data){
      this.data_dialog = data
      this.want_open = true
    },

  },
}

export default homeMixin;
